<template>
  <div
    class="wt2-message wt2-text-s"
    :class="{ expanded, expandable }"
    @click="expand"
  >
    <i v-if="icon && !expanded" class="wticon" :class="icon" />
    <span v-if="expanded">
      <slot />
    </span>
    <span class="wt2-text-n" v-if="!expanded" v-text="title" />
    <i
      v-if="expandable"
      class="wticon -arrow-icon js-stop"
      :class="[expanded ? 'wticon-collapse8' : 'wticon-Expand8']"
      @click="toggle"
    />
  </div>
</template>

<script>
export default {
  name: 'story-preview-status-message',

  data() {
    return {
      expanded: false,
      expandable:
        this.$slots && this.$slots.default && this.$slots.default.length,
    };
  },

  props: {
    icon: { type: String },
    title: { type: String },
  },

  methods: {
    expand(e) {
      if (e && e.target.classList.contains('js-stop')) {
        return;
      }

      if (this.expandable) {
        this.expanded = true;
        this.$emit('expand');
      } else {
        this.$emit('click');
      }
    },

    collapse() {
      this.expanded = false;
      this.$emit('collapse');
    },

    toggle() {
      if (this.expandable && this.expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    },
  },
};
</script>

<style scoped></style>
